import { useEffect } from 'react';
import { store } from '../../Store/store';
import { FaBell } from 'react-icons/fa';

const NotificationPopUpComponent = (props) => {
  //debugger;

  const { handleModalClose, NotificationDet } = props;
  const description = NotificationDet?.Description;

  const decodeHTML = (htmlString) => {
    if (!htmlString) return '';

    // First decode HTML entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const decodedString = tempDiv.textContent || tempDiv.innerText || '';

    // Then return the decoded string (which should now be proper HTML)
    return decodedString;
  };

  // const decodeHTML = (htmlString) => {
  //   if (!htmlString) return '';

  //   let decoded = htmlString;
  //   const tempDiv = document.createElement('div');

  //   // Decode multiple times in case of double encoding
  //   for (let i = 0; i < 3; i++) {
  //     tempDiv.innerHTML = decoded;
  //     const newDecoded = tempDiv.innerHTML;
  //     if (newDecoded === decoded) break; // No more changes
  //     decoded = newDecoded;
  //   }

  //   return decoded;
  // };

  const hasContent = description && description.replace(/<[^>]*>/g, '').trim().length > 0;

  return (
    <div className="modal-backdrop">
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" style={{ maxWidth: '550px' }} role="document">
          <div className="modal-content mb-0 p-0" style={{ maxHeight: '500px', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header p-2-5" style={{ flexShrink: 0 }}>
              <h5 className="modal-title"> <FaBell /> Important Update</h5>
              <button type="button" className="btn-close" onClick={handleModalClose}></button>
            </div>
            <div className="modal-body p-3" style={{
              overflowY: 'auto',
              flex: 1,
              minHeight: 0
            }}>
              <div style={{ fontSize: '0.8rem' }}>
                {hasContent ? (
                  <div dangerouslySetInnerHTML={{ __html: decodeHTML(description) }} />
                ) : (
                  <div>
                    No description found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotificationPopUpComponent;